// product items alignment
function equalHeight($trigger) {
  let triggerEle = document.querySelectorAll($trigger),
      cacheHeight = 0;
  triggerEle.forEach(ele => {
    let triggerHeight = ele.clientHeight;
    (triggerHeight > cacheHeight) ? cacheHeight = triggerHeight : cacheHeight = cacheHeight;
  })
  triggerEle.forEach(ele => {
    ele.style.height = `auto`
  })
}

function equalHeight1($trigger) {
  let triggerEle = document.querySelectorAll($trigger),
      cacheHeight = 0;
  triggerEle.forEach(ele => {
    let triggerHeight = ele.clientHeight;
    (triggerHeight > cacheHeight) ? cacheHeight = triggerHeight : cacheHeight = cacheHeight;
  })
  triggerEle.forEach(ele => {
    ele.style.height = `${cacheHeight}px`
  })
}
// equal Height on product cards
['DOMContentLoaded','load'].forEach(event => {
  window.addEventListener(event, () => {
    // equal Height on product price
    equalHeight('.product-item__inner .product-item__price');
  
    // equal Height on product title
    equalHeight1('.product-item__inner .product-item__product-title a');

  })
}) 